// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eazi","toggle":"styles_toggle__iNpFd","preview":"styles_preview__1ngTg"};